import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiPlus, FiEdit2, FiTrash2, FiCalendar, FiUsers, FiMapPin, FiInbox, FiAlertTriangle, FiCopy } from 'react-icons/fi';

// Firebase importok - BŐVÍTVE: doc, deleteDoc
import { db, auth } from '../../firebase'; 
import { collection, query, where, onSnapshot, doc, deleteDoc, getDocs, writeBatch } from 'firebase/firestore';

const ClubDashboard = () => {
  const navigate = useNavigate();
  const [competitions, setCompetitions] = useState([]);
  const [closedCompetitions, setClosedCompetitions] = useState([]); // ÚJ: Lezárt versenyek állapota
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState('active');

  // --- MODAL ÁLLAPOTOK ---
  const [showModal, setShowModal] = useState(false);
  const [compToDelete, setCompToDelete] = useState(null);

  // 1. Auth állapot figyelése
  useEffect(() => {
    const unsubscribeAuth = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      if (!currentUser) setLoading(false);
    });
    return () => unsubscribeAuth();
  }, []);

  // 2. Adatok lekérése - INDEX-MENTESÍTVE az azonnali betöltéshez
  useEffect(() => {
    if (!user) return;

    console.log("Lekérés indítása: events, user:", user.uid);
    const q = query(
      collection(db, "events"),
      where("organizerId", "==", user.uid)
    );

    const unsubscribeSnapshot = onSnapshot(q, (querySnapshot) => {
      const comps = [];
      querySnapshot.forEach((doc) => {
        comps.push({ id: doc.id, ...doc.data() });
      });

      console.log("Aktív versenyek betöltve:", comps.length, "db");

      // MANUÁLIS RENDEZÉS
      comps.sort((a, b) => {
        const dateA = a.createdAt?.seconds || 0;
        const dateB = b.createdAt?.seconds || 0;
        return dateB - dateA;
      });

      setCompetitions(comps);
      setLoading(false);
    }, (error) => {
      console.error("Hiba az events lekérésekor:", error);
      setLoading(false);
    });

    return () => unsubscribeSnapshot();
  }, [user]);

  // 3. Lezárt adatok lekérése az events_closed gyűjteményből
  useEffect(() => {
    if (!user) return;

    console.log("Lekérés indítása: events_closed, user:", user.uid);
    const q = query(
      collection(db, "events_closed"),
      where("organizerId", "==", user.uid)
    );

    const unsubscribeClosed = onSnapshot(q, (querySnapshot) => {
      const comps = [];
      querySnapshot.forEach((doc) => {
        comps.push({ id: doc.id, ...doc.data() });
      });

      console.log("Lezárt versenyek betöltve:", comps.length, "db");

      comps.sort((a, b) => {
        const dateA = a.closedAt ? new Date(a.closedAt).getTime() : 0;
        const dateB = b.closedAt ? new Date(b.closedAt).getTime() : 0;
        return dateB - dateA;
      });

      setClosedCompetitions(comps);
    }, (error) => {
      console.error("Hiba az events_closed lekérésekor:", error);
    });

    return () => unsubscribeClosed();
  }, [user]);

  // --- TÖRLÉS LOGIKA ---
  const openDeleteModal = (comp) => {
    setCompToDelete(comp);
    setShowModal(true);
  };

  const handleFinalDelete = async () => {
    if (!compToDelete) return;

    const collectionName = activeTab === 'active' ? "events" : "events_closed";

    try {
      const batch = writeBatch(db);

      // 1. Nevezők (participants) lekérése és törlése a batch-ben
      const participantsRef = collection(db, collectionName, compToDelete.id, "participants");
      const participantsSnap = await getDocs(participantsRef);
      participantsSnap.forEach((participantDoc) => {
        batch.delete(participantDoc.ref);
      });

      // 2. A verseny fő dokumentumának hozzáadása a törlési listához
      batch.delete(doc(db, collectionName, compToDelete.id));

      // 3. Végrehajtjuk a teljes törlést egyszerre
      await batch.commit();
      
      // Frissítjük a helyi állapotot
      if (activeTab === 'active') {
        setCompetitions(prev => prev.filter(c => c.id !== compToDelete.id));
      } else {
        setClosedCompetitions(prev => prev.filter(c => c.id !== compToDelete.id));
      }
      
      setShowModal(false);
      setCompToDelete(null);
    } catch (error) {
      console.error("Hiba a törlés során:", error);
      alert("A törlés sikertelen!");
    }
  };

  const handleCopyCompetition = (comp) => {
    // Adatok másolása és tisztítása
    const {
      id,
      participantsCount,
      createdAt,
      closedAt,
      status,
      registrationClosed,
      competitionDate,
      startDate,
      endDate,
      registrationDeadline,
      registrationChangeDeadline,
      ...rest
    } = comp;

    const copiedData = {
      ...rest,
      competitionName: `${comp.competitionName || comp.title} (MÁSOLAT)`,
      // Dátumokat ürítjük, hogy a szervezőnek meg kelljen adnia az újat
      competitionDate: '',
      startDate: '',
      endDate: '',
      registrationDeadline: '',
      registrationChangeDeadline: '',
      creationType: 'full_event',
      status: 'Aktív'
    };

    navigate('/verseny-letrehozas', { state: { copiedCompetition: copiedData } });
  };

  // Statisztika számítása
  const totalParticipants = competitions.reduce((sum, comp) => sum + (Number(comp.participantsCount) || 0), 0);

  if (loading && !user) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p style={{ fontSize: '1.2rem', color: '#b30000', fontWeight: 'bold' }}>Betöltés...</p>
      </div>
    );
  }

  // Versenyek szétválogatása
  const activeCompetitions = competitions;
  const pastCompetitions = closedCompetitions;
  
  // Éppen megjelenítendő lista
  const displayCompetitions = activeTab === 'active' ? activeCompetitions : pastCompetitions;

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
      
      {/* --- EGYEDI TÖRLÉSI ABLAK (MODAL) --- */}
      {showModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <FiAlertTriangle size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Biztosan törölni szeretnéd?</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              Valóban törölni szeretnéd a(z) <br/>
              <strong>{compToDelete?.competitionName || compToDelete?.title}</strong> <br/>
              versenyt? Ez a művelet végleges.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button 
                style={modalCancelButtonStyle} 
                onClick={() => setShowModal(false)}
              >
                Mégse
              </button>
              <button 
                style={modalDeleteButtonStyle} 
                onClick={handleFinalDelete}
              >
                Igen, törlöm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* FEJLÉC ÉS ÚJ VERSENY GOMB */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
        <div>
          <h2 style={{ color: '#b30000', margin: 0 }}>Egyesületi Irányítópult</h2>
          <p style={{ color: '#666', marginTop: '5px' }}>Kezeld a versenyeidet és a nevezéseket.</p>
        </div>
        <button 
          style={createButtonStyle} 
          onClick={() => navigate('/verseny-letrehozas')}
        >
          <FiPlus /> Új verseny létrehozása
        </button>
      </div>

      {/* STATISZTIKAI GYORSNÉZET */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '40px' }}>
        <div style={statCardStyle}>
          <span style={{ fontSize: '14px', color: '#888' }}>Következő esemény</span>
          <h3 style={{ fontSize: '18px', margin: '5px 0', color: '#b30000' }}>
            {activeCompetitions.length > 0
              ? (activeCompetitions[0].competitionDate || "Nincs megadva dátum")
              : "Nincs tervezett esemény"}
          </h3>
        </div>
      </div>

            {/* VERSENYEK LISTÁJA - TABS ELRENDEZÉSSEL */}
      <div style={tabContainerStyle}>
        <div 
          style={tabStyle(activeTab === 'active')} 
          onClick={() => setActiveTab('active')}
        >
          Aktív versenyeid ({activeCompetitions.length})
        </div>
        <div 
          style={tabStyle(activeTab === 'past')} 
          onClick={() => setActiveTab('past')}
        >
          Lezárt versenyek ({pastCompetitions.length})
        </div>
      </div>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        {displayCompetitions.length > 0 ? (
          displayCompetitions.map((comp) => (
            <div key={comp.id} style={compCardStyle}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                <span style={statusBadgeStyle(comp.status || 'Aktív')}>{comp.status || 'Aktív'}</span>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <FiCopy
                    style={{ cursor: 'pointer', color: '#1877F2' }}
                    title="Másolás új versenynek"
                    onClick={() => handleCopyCompetition(comp)}
                  />
                  {activeTab === 'active' && (
                    <FiEdit2
                      style={{ cursor: 'pointer', color: '#666' }}
                      title="Szerkesztés"
                      onClick={() => navigate(`/verseny-szerkesztes/${comp.id}`)}
                    />
                  )}
                  {activeTab === 'active' && (
                    <FiTrash2
                      style={{ cursor: 'pointer', color: '#b30000' }}
                      title="Törlés"
                      onClick={() => openDeleteModal(comp)}
                    />
                  )}
                </div>
              </div>
              
              <h4 style={{ margin: '0 0 15px 0', fontSize: '18px' }}>{comp.competitionName || comp.title}</h4>
              
              <div style={infoRowStyle}>
                <FiCalendar /> {comp.competitionDate || 'Nincs megadva dátum'}
              </div>
              <div style={infoRowStyle}><FiMapPin /> {comp.location || 'Nincs megadva helyszín'}</div>
              <div style={infoRowStyle}><FiUsers /> {comp.participantsCount || 0} nevező regisztrált</div>
              
              <button 
                style={manageButtonStyle}
                onClick={() => navigate(`/versenyiroda/${comp.id}`)}
              >
                Versenyiroda
              </button>
            </div>
          ))
        ) : (
          <div style={emptyStateStyle}>
            <FiInbox size={50} style={{ marginBottom: '15px', color: '#ccc' }} />
            <p style={{ margin: 0, fontWeight: 'bold', color: '#888' }}>
              {activeTab === 'active' ? "Még nincsenek aktív versenyeid." : "Még nincsenek lezárt versenyeid."}
            </p>
            {activeTab === 'active' && (
              <p style={{ fontSize: '14px', color: '#aaa' }}>Kattints az "Új verseny létrehozása" gombra!</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

// --- STÍLUSOK (Visszaállítva multiline formátumba) ---

const tabContainerStyle = {
  display: 'flex',
  gap: '30px',
  marginBottom: '25px',
  borderBottom: '1px solid #eee'
};

const tabStyle = (isActive) => ({
  padding: '10px 5px',
  fontSize: '18px',
  fontWeight: 'bold',
  cursor: 'pointer',
  color: isActive ? '#b30000' : '#888',
  borderBottom: isActive ? '3px solid #b30000' : '3px solid transparent',
  transition: '0.3s ease'
});

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
  backdropFilter: 'blur(3px)'
};

const modalContentStyle = {
  backgroundColor: 'white',
  padding: '30px',
  borderRadius: '15px',
  textAlign: 'center',
  maxWidth: '400px',
  width: '90%',
  boxShadow: '0 15px 35px rgba(0,0,0,0.3)'
};

const modalDeleteButtonStyle = {
  backgroundColor: '#b30000',
  color: 'white',
  border: 'none',
  padding: '12px 24px',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const modalCancelButtonStyle = {
  backgroundColor: '#eee',
  color: '#333',
  border: 'none',
  padding: '12px 24px',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const createButtonStyle = {
  backgroundColor: '#b30000',
  color: 'white',
  border: 'none',
  padding: '12px 20px',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  fontSize: '16px',
  transition: '0.2s'
};

const statCardStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
  borderLeft: '4px solid #b30000'
};

const compCardStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '12px',
  boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
  position: 'relative'
};

const emptyStateStyle = {
  gridColumn: '1 / -1',
  textAlign: 'center',
  padding: '60px 20px',
  backgroundColor: '#fdfdfd',
  borderRadius: '12px',
  border: '2px dashed #eee',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
};

const statusBadgeStyle = (status) => ({
  backgroundColor: status === 'Aktív' ? '#e6fffa' : '#fffaf0',
  color: status === 'Aktív' ? '#2c7a7b' : '#b7791f',
  padding: '4px 10px',
  borderRadius: '20px',
  fontSize: '12px',
  fontWeight: 'bold'
});

const infoRowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '14px',
  color: '#555',
  marginBottom: '8px'
};

const manageButtonStyle = {
  width: '100%',
  marginTop: '15px',
  padding: '10px',
  backgroundColor: 'transparent',
  border: '1.5px solid #b30000',
  color: '#b30000',
  borderRadius: '6px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

export default ClubDashboard;


